import React from "react";
import styles from "../css/IcoHamburger.module.css";
import clsx from "clsx";

interface IcoHamburgerProps {
  isOpen?: boolean;
}

export const IcoHamburger = ({ isOpen = false }: IcoHamburgerProps) => {
  return (
    <div className={clsx(styles.hamburger, isOpen && styles.open)}>
      <span className={styles.bar}></span>
      <span className={styles.bar}></span>
      <span className={styles.bar}></span>
    </div>
  );
};

export default IcoHamburger;